import PropTypes from "prop-types";

const ErrorSummary = ({ errors = [] }) => {
  const normalizedErrors = (errors || []).filter(Boolean);

  if (normalizedErrors.length === 0) {
    return null;
  }

  return (
    <div className="alert alert-danger">
      <ul className="mb0 pl3">
        {normalizedErrors.map((error) => (
          <li key={error}>{error}</li>
        ))}
      </ul>
    </div>
  );
};

ErrorSummary.propTypes = {
  errors: PropTypes.arrayOf(PropTypes.string),
};

export default ErrorSummary;
